<!-- //
组件工作台设计区域-右击菜单
@auth xuyd
@date 2025-05-04
//-->
<template>
  <ul class="context-menu" :style="{left:ctxData.left + 'px',top: ctxData.top + 'px'}" v-show="visible">
    <li :class="{}" @click.stop="handleMenuCmd('copy')">
      <i class="el-icon-document-copy"></i><span class="label">复制图层</span>
    </li>
    <li :class="{}" @click.stop="handleMenuCmd('remove')">
      <i class="el-icon-close"></i><span class="label">删除图层</span>
    </li>
    <li :class="{'disable':isTopView()}" @click.stop="handleMenuCmd('top',isTopView())" v-if="false">
      <i class="el-icon-upload2"></i><span class="label">置顶图层</span>
    </li>
    <li :class="{'disable':isBottomView()}" @click.stop="handleMenuCmd('bottom', isBottomView())" v-if="false">
      <i class="el-icon-download"></i><span class="label">置底图层</span>
    </li>
    <li :class="{'disable':isTopView()}" @click.stop="handleMenuCmd('up',isTopView())">
      <i class="el-icon-top"></i><span class="label">上移一层</span>
    </li>
    <li :class="{'disable':isBottomView()}" @click.stop="handleMenuCmd('down',isBottomView())">
      <i class="el-icon-bottom"></i><span class="label">下移一层</span>
    </li>
  </ul>
</template>

<script>
import * as WidgetUtil from "@/views/datavisual/utils/util";
import DataScreenApi from "@/api/datavisual/dataScreen.api";

export default {
  name: 'WbContextMenu',
  data() {
    return {
      visible: false,
      ctxData: {
        left: 0,
        top: 0,
        widgetData: {}
      },
    };
  },
  props: {
    widgetViewList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  methods: {
    openMenu(data) {
      this.visible = true;
      this.ctxData = {...data};
    },
    closeMenu() {
      this.visible = false;
    },

    isTopView() {
      return this.ctxData.widgetData.isHead;
    },
    isBottomView() {
      return this.ctxData.widgetData.isTail;
    },

    /**
     * 菜单上下文操作，上移动，下移动，复制，删除
     * 菜单操作都执行db操作
     *
     * @param command
     * @param disable
     */
    handleMenuCmd(command, disable) {
      if(disable) return;
      let item = this.ctxData.widgetData;
      switch (command) {
        case 'up':
          WidgetUtil.arrayMoveUp(this.widgetViewList, item);
          this.closeMenu();
          break;
        case 'down':
          WidgetUtil.arrayMoveDown(this.widgetViewList, item);
          this.closeMenu();
          break;
        case 'top':
          this.closeMenu();
          break;
        case 'bottom':
          console.log('===copy======>', this.widgetViewList);
          this.closeMenu();
          break;
        case 'copy':
          DataScreenApi.addWidget(item).then(resp => {
            this.closeMenu();
            this.widgetViewList.push(resp.data);
            this.$modal.msgSuccess("复制成功");
            console.log('===copy======>', this.widgetViewList)
          });
          break;
        case 'remove':
          DataScreenApi.deleteWidget(item.id).then(resp => {
            this.closeMenu();
            WidgetUtil.arrayRemove(this.widgetViewList, item);
            this.$modal.msgSuccess("删除成功");
            // console.log('===remove======>', this.widgetViewList)
          });
          break;
      }
    }
  }
}
</script>
<style lang="less" scoped>

@import '../../assets/css/variables.less';

.context-menu {
  margin: 0;
  width: 150px;
  background-color: @dv_background_bg;
  z-index: 9999;
  position: fixed;
  list-style-type: none;
  padding: 5px 5px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: @dv_form_input_color;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

  .disable {
    color: #8C8C8C;
  }

  li {
    margin: 0;
    padding: 10px;
    cursor: pointer;

    .label {
      margin-left: 10px;
    }
  }

  li:not(.disable):hover {
    background-color: #263445;
  }

}
</style>
